import { cn } from '@/lib/utils';

export function HoneyScoreBar({
  value,
  max = 100,
  className,
}: {
  value: number;
  max?: number;
  className?: string;
}) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-end justify-between">
        <div className="text-xs uppercase tracking-widest text-gray-400">꿀통지수</div>
        <div className="text-xs font-bold text-gold">🍯 Honey</div>
      </div>
      <div className="flex items-baseline gap-2">
        <span className="tabular text-3xl font-extrabold text-white">{value.toFixed(1)}</span>
        <span className="text-gray-500">/ {max}</span>
      </div>
      <div className="h-2 w-full rounded-full bg-gray-800 overflow-hidden">
        <div
          className="h-full rounded-full bg-gradient-to-r from-[#FFA500] via-[#FFD700] to-[#FFF066] transition-[width] duration-700"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
